export default {
  carmap: "/api/v1/banner/carmap/", // 获取首页轮播图
  signin: "/api/v1/membership/signin/", // 签到
};
